"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.classConcat = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactScrollmagic = require("react-scrollmagic");

var _reactParallaxTilt = _interopRequireDefault(require("react-parallax-tilt"));

var _CardHeadline = _interopRequireDefault(require("../cardheadline/CardHeadline"));

var _CardModule = _interopRequireDefault(require("./Card.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const RADIAL_GRADIENT = 'radial-gradient';
const BACKGROUND = 'background';
const RIGHT = 'right',
      LEFT = 'left',
      TOP = 'top',
      BOTTOM = 'bottom';

function getGlowStyles(glowType, glowColor) {
  if (glowType === RADIAL_GRADIENT) return {
    background: "radial-gradient(".concat(glowColor, " -90%, transparent 60%)")
  };else if (glowType === BACKGROUND) return {
    filter: "drop-shadow(10px 10px 25px ".concat(glowColor, ") drop-shadow(-10px -10px 25px ").concat(glowColor, ")")
  };else {
    return {};
  }
}

function getPositionedChildren(children) {
  const positionedChildren = {
    right: [],
    left: [],
    top: [],
    bottom: []
  };

  if (children) {
    children = _react.Children.toArray(children);

    for (let index in children) {
      if ( /*#__PURE__*/_react.default.isValidElement(children[index])) {
        switch (children[index].props.position) {
          case TOP:
            positionedChildren.top.push(children[index]);
            break;

          case BOTTOM:
            positionedChildren.bottom.push(children[index]);
            break;

          case RIGHT:
            positionedChildren.right.push(children[index]);
            break;

          case LEFT:
          default:
            positionedChildren.left.push(children[index]);
        }
      }
    }
  }

  return positionedChildren;
}

const classConcat = function classConcat() {
  let concat = '';

  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  for (let index in classes) {
    concat += classes[index] + ' ';
  }

  return concat;
};
/*
    Card reusable component
    props:
        - glowColor: specifies the color of the backGround glow
          (if not specified, no glow is rendered at all)
        - glowType: tells which kind of glow is required to be drawn
          (defaults to 'radial-gradient' but takes effect only when a glowColor is specified)
        - headline: card headline text
        - paragraph: card paragraph text
        - children: additional content to be displayed
          (an icon for example)
          Note that every children needs to communicate to its parent the position it wants to be rendered in
          (defaults to 'left', other possibilities are 'right', 'bottom', 'top', on mobile they are stacked in the 
          order: top, left, defaulf card content, right bottom)
        - childrenClassName: specifies eventual css classes to override default styles provided.
        - className: classes applyed to the card container; can be used to inject background
          related styles or some global typograpy configuration.
        - responsive: boolean, set if the card need to be responsively rendered
          (defaults to true)
        - glassmorphism: defaults to true, make the card background glassmorphic
        - tilt: boolean, enables or not the tilt animation on hover (defaults to true)

    Note that the component does not set any font or typografy config by itself and takes everything from the root
    styles. Local styles can be applied with the 'className' property. Fonts changing size responsively are assumed
    to be coerent througout the application, so it is supposed any responsive behavoir is defined globally.
*/


exports.classConcat = classConcat;

const Card = props => {
  const glowStyles = getGlowStyles(props.glowType, props.glowColor);
  const positionedChildren = getPositionedChildren(props.children);
  const leftChildren = positionedChildren.left.length,
        rightChildren = positionedChildren.right.length,
        topChildren = positionedChildren.top.length,
        bottomChildren = positionedChildren.bottom.length;
  return /*#__PURE__*/_react.default.createElement(_reactScrollmagic.Scene, {
    classToggle: _CardModule.default.visible,
    triggerHook: 0.9,
    offset: -100,
    reverse: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CardModule.default.animatedOnEnter
  }, /*#__PURE__*/_react.default.createElement(_reactParallaxTilt.default, {
    tiltEnable: props.tilt ? true : false,
    perspective: 1000,
    className: classConcat(props.className, _CardModule.default.cardContainer, _CardModule.default.preserve3d, props.glassmorphism === true ? _CardModule.default.glassmorphic : '', props.responsive === true ? _CardModule.default.responsive : ''),
    style: props.glowType === BACKGROUND ? glowStyles : {}
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CardModule.default.cardWrapper
  }, topChildren !== 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: classConcat(_CardModule.default.wrapper, _CardModule.default.wrapperTop, props.childrenClassName)
  }, positionedChildren.top.map(child => /*#__PURE__*/_react.default.createElement("div", null, child))), /*#__PURE__*/_react.default.createElement("div", {
    className: _CardModule.default.horizontalWrapper
  }, leftChildren !== 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: classConcat(_CardModule.default.wrapper, _CardModule.default.wrapperLeft, props.childrenClassName)
  }, positionedChildren.left.map(child => /*#__PURE__*/_react.default.createElement("div", null, child))), /*#__PURE__*/_react.default.createElement("div", {
    className: _CardModule.default.textWrapper
  }, /*#__PURE__*/_react.default.createElement(_CardHeadline.default, {
    text: props.headline
  }), /*#__PURE__*/_react.default.createElement("article", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, props.paragraph)), rightChildren !== 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: classConcat(_CardModule.default.wrapper, _CardModule.default.wrapperRight, props.childrenClassName)
  }, positionedChildren.right.map(child => /*#__PURE__*/_react.default.createElement("div", null, child)))), bottomChildren !== 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: classConcat(_CardModule.default.wrapper, _CardModule.default.wrapperBottom, props.childrenClassName)
  }, positionedChildren.bottom.map(child => /*#__PURE__*/_react.default.createElement("div", null, child)))), props.glowColor && props.glowType === RADIAL_GRADIENT && /*#__PURE__*/_react.default.createElement("div", {
    className: _CardModule.default.backGlow,
    style: glowStyles
  }))));
};

Card.defaultProps = {
  glowColor: null,
  glowType: 'radial-gradient',
  headline: '',
  paragraph: '',
  className: '',
  childrenClassName: '',
  responsive: true,
  glassmorphism: true,
  tilt: true
};
var _default = Card;
exports.default = _default;